/**
 * Função para disparar um evento customizado
 * @param eventName Nome do evento
 * @param detail Dados adicionais do evento
 * @param target Elemento alvo do evento (opcional, padrão é window)
 */
export const dispatchCustomEvent = <T = any>(
  eventName: string,
  detail?: T,
  target: EventTarget = window
): void => {
  let userData = null;
  if (typeof window !== "undefined") {
    const userStr = localStorage.getItem("@user");
    if (userStr) {
      try {
        userData = JSON.parse(userStr);
      } catch {
        userData = null;
      }
    }
  }

  // Dispara o evento customizado
  const event = new CustomEvent(eventName, {
    detail: {
      ...detail,
      userId: userData?.customer?.id || null,
    },
    bubbles: true,
    cancelable: true,
  });

  target.dispatchEvent(event);

  // Dispara o evento no dataLayer do GTM
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...detail,
      userId: userData?.customer?.id || null,
    });
  }
};

/**
 * Função para disparar um evento apenas no dataLayer do GTM
 * @param eventName Nome do evento
 * @param detail Dados adicionais do evento
 */
export const dispatchDataLayerEvent = <T = any>(
  eventName: string,
  detail?: T
): void => {
  let userData = null;
  if (typeof window !== "undefined") {
    const userStr = localStorage.getItem("@user");
    if (userStr) {
      try {
        userData = JSON.parse(userStr);
      } catch {
        userData = null;
      }
    }
  }

  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...detail,
      userId: userData?.customer?.id || null,
    });
  }
};

/**
 * Função para adicionar um listener de evento customizado
 * @param eventName Nome do evento
 * @param callback Função a ser executada quando o evento for disparado
 * @param target Elemento alvo do evento (opcional, padrão é window)
 */
export const addCustomEventListener = <T = any>(
  eventName: string,
  callback: (event: CustomEvent<T>) => void,
  target: EventTarget = window
): void => {
  target.addEventListener(eventName, callback as EventListener);
};

/**
 * Função para remover um listener de evento customizado
 * @param eventName Nome do evento
 * @param callback Função que será removida
 * @param target Elemento alvo do evento (opcional, padrão é window)
 */
export const removeCustomEventListener = <T = any>(
  eventName: string,
  callback: (event: CustomEvent<T>) => void,
  target: EventTarget = window
): void => {
  target.removeEventListener(eventName, callback as EventListener);
};
